import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../utils/test-utils/unidriver';
import {
  testkit as inputTestKit,
  InputUniDriver,
} from '../../Input/Input.uni.driver';
import { UniDriver } from '@wix/unidriver-core';

export type DateInputUniDriver = BaseUniDriver & InputUniDriver;

export const dateInputDriverFactory = (base: UniDriver): DateInputUniDriver => {
  // TODO - replace this when uniDriver support is added to input
  return {
    ...baseUniDriverFactory(base),
    ...inputTestKit(base, base),
  };
};
